/** The Create stage action element; its fields edit real stage fields, so they read the WorkOrder metadata. */
import { MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { ActivityEntityName } from '../../shared/activity.entity.name';
import { WorkflowActionType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowSideEffect } from '../workflow.element';

/** Adds a stage to the run's Job, once per run and step. */
export const CREATE_JOB_STAGE_ELEMENT: WorkflowElement = {
    type: WorkflowActionType.CreateJobStage,
    family: WorkflowFamily.Stage,
    sideEffect: WorkflowSideEffect.Write,
    title: 'Add a stage to the Job',
    icon: 'fa-square-plus',
    fields: [
        {
            bind: 'input.name',
            required: true,
            entity: ActivityEntityName.WorkOrder,
            field: 'name',
            metadata: { displayName: 'Stage name' },
        },
        {
            bind: 'input.workCategoryId',
            entity: ActivityEntityName.WorkOrder,
            field: 'workCategory',
            metadata: { displayName: 'Category' },
        },
        {
            bind: 'input.startDate',
            entity: ActivityEntityName.WorkOrder,
            field: 'startDate',
        },
        {
            bind: 'input.dueDate',
            entity: ActivityEntityName.WorkOrder,
            field: 'dueDate',
        },
    ],
    outputs: [
        { path: 'stageId', metadata: { displayName: 'Stage ID', type: MetadataEntityFieldType.Lookup, entity: ActivityEntityName.WorkOrder } },
    ],
};
